module.exports = __webpack_public_path__ + "static/media/display-suite-18.49112256.jpg";